import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import HeaderComponent from '../components/General/HeaderComponent';
import ButtonComponent from '../components/General/Button';
import { postProjectsCreate } from '../services/projects';
import { Notify } from 'notiflix';

export default function CreateProjectCheck() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { projectDetails } = useSelector((state) => state.createProjectState);

  const handleCreateProject = async () => {
    try {
      // API'ye göndereceğimiz data formatı
      const apiData = {
        pname: projectDetails.pname,
        pdesc: projectDetails.pdesc,
        pbudget: projectDetails.pbudget || "0",
        penddate: projectDetails.penddate || Math.floor(Date.now() / 1000) + (30 * 24 * 60 * 60), // 30 gün sonra default
        pfirm: projectDetails.pfirm
      };

      const response = await postProjectsCreate(apiData);
      
      if (response) {
        Notify.success('Proje başarıyla oluşturuldu!');
        navigate('/projects/create/finish');
      } else {
        throw new Error('API yanıtı boş');
      }
    } catch (error) {
      console.error('Proje oluşturulurken hata:', error);
      Notify.failure('Proje oluşturulurken bir hata oluştu.');
    }
  };

  return (
    <div className="w-full dark:bg-dark-100 bg-stone-100 min-h-screen">
      <div className="container mx-auto">
        <HeaderComponent title="Proje Bilgilerini Kontrol Et" />
        
        <div className="flex justify-center items-center mt-8">
          <div className="bg-white dark:bg-dark-300 p-6 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-700 max-w-4xl w-full">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
              </div>
              <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
                Proje Bilgilerinizi Kontrol Edin
              </h2>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Aşağıdaki bilgileri kontrol edin ve doğruysa projeyi oluşturun.
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Sol Sütun */}
              <div className="space-y-4">
                <div className="bg-gray-50 dark:bg-dark-500 p-4 rounded-xl border border-gray-200 dark:border-gray-600">
                  <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2 uppercase tracking-wide">
                    Proje Adı
                  </h3>
                  <p className="text-gray-900 dark:text-white font-medium">
                    {projectDetails.pname || 'Belirtilmemiş'}
                  </p>
                </div>

                <div className="bg-gray-50 dark:bg-dark-500 p-4 rounded-xl border border-gray-200 dark:border-gray-600">
                  <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2 uppercase tracking-wide">
                    Firma Adı
                  </h3>
                  <p className="text-gray-900 dark:text-white font-medium">
                    {projectDetails.pfirm || 'Belirtilmemiş'}
                  </p>
                </div>
              </div>

              {/* Sağ Sütun */}
              <div className="space-y-4">
                <div className="bg-gray-50 dark:bg-dark-500 p-4 rounded-xl border border-gray-200 dark:border-gray-600">
                  <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2 uppercase tracking-wide">
                    Proje Bütçesi
                  </h3>
                  <p className="text-gray-900 dark:text-white font-medium">
                    {projectDetails.pbudget ? `₺${projectDetails.pbudget}` : 'Belirtilmemiş'}
                  </p>
                </div>

                <div className="bg-gray-50 dark:bg-dark-500 p-4 rounded-xl border border-gray-200 dark:border-gray-600">
                  <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2 uppercase tracking-wide">
                    Tahmini Bitiş Tarihi
                  </h3>
                  <p className="text-gray-900 dark:text-white font-medium">
                    {projectDetails.penddate 
                      ? new Date(projectDetails.penddate * 1000).toLocaleDateString('tr-TR')
                      : 'Belirtilmemiş (30 gün sonra varsayılan)'}
                  </p>
                </div>

                <div className="bg-gray-50 dark:bg-dark-500 p-4 rounded-xl border border-gray-200 dark:border-gray-600">
                  <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2 uppercase tracking-wide">
                    Proje Açıklaması
                  </h3>
                  <p className="text-gray-900 dark:text-white font-medium text-sm leading-relaxed">
                    {projectDetails.pdesc || 'Belirtilmemiş'}
                  </p>
                </div>
              </div>
            </div>

            <div className="flex justify-center space-x-4 mt-8">
              <ButtonComponent
                href="/projects/create/details"
                title="Geri"
                bgcolor="bg-gray-100 text-black rounded-xl w-44 dark:bg-dark-300 dark:text-gray-300 hover:bg-stone-200 border-2 dark:border-dark-500 dark:hover:border-violet-500"
              />
              <ButtonComponent
                onClick={handleCreateProject}
                title="Projeyi Oluştur"
                bgcolor="bg-red-600 rounded-xl text-white w-44 dark:bg-violet-500 hover:bg-violet-500"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
